import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// @ts-ignore
import traverseISODate from '@segment/isodate-traverse';
export const buildContext = context => {
  return _objectSpread(_objectSpread({}, context.context), {}, {
    userAgent: navigator.userAgent
  });
};
export const prepareEventProperties = properties => {
  const propertiesWithoutUndefined = nestedRemoveUndefinedValues(properties, '$.properties');
  return traverseISODate(propertiesWithoutUndefined);
};

// This function will essentially deepClone as well
const nestedRemoveUndefinedValues = (obj, path) => {
  const recursionDepthLimit = 512;
  const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth) => {
    if (source === null || typeof source !== 'object') {
      return source;
    }

    // If the level of nesting is egregiously excessive we'll stop processing any further to
    // avoid crashing due to stack exhaustion, instead we return a note object.
    if (depth > recursionDepthLimit) {
      return {
        _depthLimitExceeded: true,
        message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
      };
    }

    // If this object has already been seen then processing it would create a circular reference,
    // instead we return a note object.
    if (processedReferences.has(source)) {
      const originalPath = processedReferences.get(source);
      return {
        _circularReference: true,
        message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
        originalPath: originalPath
      };
    }
    processedReferences.set(source, path);
    const clone = {};
    Object.keys(source).forEach(key => {
      const value = source[key];
      if (value !== undefined) {
        if (Array.isArray(value)) {
          const newArray = [];
          value.forEach((v, i) => {
            const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
            if (newValue !== undefined) {
              newArray.push(newValue);
            }
          });
          clone[key] = newArray;
        } else {
          const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
          if (newValue !== undefined) {
            clone[key] = newValue;
          }
        }
      }
    });
    processedReferences.delete(source);
    return clone;
  };
  return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};